import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function ClientUpdateForm({ clientData }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    address: ""
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("Client Update  Form Component Launched with props:");
    console.log(clientData);
    setFormData({
      firstName: clientData.firstName,
      lastName: clientData.lastName,
      email: clientData.email,
      telephone: clientData.telephone,
      address: clientData.address
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClientUpdate = (event) => {
    event.preventDefault();
    console.log("Submitting Client Update");
    console.log(formData);

    const clientInformation = formData;

    API.updateClient(clientData._id, clientInformation).then((_res) => {
      console.log("Updated Client!");
      console.log(_res.data);
      cogoToast.success("Client has been updated!");
    });
  };

  return (
    <div>
      <div className="card">
        <h5 style={{ textAlign: "center" }}>Update Client</h5>

        <div className="card-body">
          <form>
            <Table bordered hover>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    First Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      name="firstName"
                      placeholder="First Name"
                    />
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Last Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      name="lastName"
                      placeholder="Last Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Email
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.email}
                      onChange={handleInputChange}
                      name="email"
                      placeholder="E-mail"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Phone
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      name="telephone"
                      placeholder="Phone #"
                    />
                  </td>
                  <td></td>
                </tr>

                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Full Address
                  </td>
                  <td style={{ width: "300px" }}>
                    <input
                      type="text"
                      value={formData.address}
                      onChange={handleInputChange}
                      name="address"
                      placeholder="Complete Address"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  ></td>
                  <td style={{ width: "300px" }}></td>
                </tr>

                <tr></tr>
              </tbody>
            </Table>

            <div style={{ textAlign: "center" }}>
              <button className="btn-success btn-sm btn" onClick={(e) => handleClientUpdate(e)}>
                Update Client
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ClientUpdateForm;
